export interface IJsonRpcResponse {
  id: any
  result: {}
}

interface IConfig {
  authToken: string | null
  url: string | null,
  environment: string,
}

export const config:IConfig = {
  authToken: localStorage.getItem('token'),
  environment: 'production',
  url: null,
};

// Technique cribbed from https://daveceddia.com/multiple-environments-with-react/
const hostname = window && window.location && window.location.hostname;

switch (hostname) {
  case 'app.sharpspring.localhost.com':
    config.environment = 'development';
    config.url = 'http://' + hostname + ':16562/siteApi';
    break;
  case 'finance-staging.sharpspring.com':
    config.environment = 'staging';
    config.url = 'https://' + hostname + '/siteApi';
    break;
  case 'finance.sharpspring.com':
    config.url = 'https://' + hostname + '/siteApi';
    break;
}
